import React from "react";
import { searchType } from "../../../common/types/search/search";

export function AlertLink({ search }: { search: searchType }) {
	const createAlertLink = (
		<a
			href={"account-management/alerts/saved-search/" + search.id}
			className="btn btn--secondary btn--icon btn--create-alert"
			title="Create alert"
		>
			Create alert
		</a>
	);

	const editAlertLink = (
		<a
			href={"account-management/alerts/" + search.alertId}
			className="btn btn--secondary btn--icon btn--edit"
			title="Edit alert"
		>
			Edit alert
		</a>
	);

	return search.alertId ? editAlertLink : createAlertLink;
}
